import React from "react";

import Tooltip from "antd/es/tooltip";
import { get } from "lodash-es";
import { useIntl } from "react-intl";

import { Deal, EntityType } from "@mapmycustomers/shared/types/entity";

import ButtonLink from "@app/component/ButtonLink";
import { RegistryProps } from "@app/component/FieldGrid/utils/ComponentRegistry";
import useEntityLinkGetter from "@app/util/contexts/useEntityLinkGetter";

const DealField = ({ entity, field }: RegistryProps) => {
  const intl = useIntl();
  const getEntityLink = useEntityLinkGetter();

  const dealName = field.getFormattedValueFor(entity);
  const deal = get(entity, field.name) as Deal;

  return (
    <Tooltip
      placement="bottom"
      title={intl.formatMessage({
        id: "fieldGrid.field.deal.tooltip",
        defaultMessage: "Open Deal",
        description: "Open deal tooltip",
      })}
    >
      <ButtonLink href={getEntityLink(EntityType.DEAL, deal.id)} target="_blank">
        {dealName}
      </ButtonLink>
    </Tooltip>
  );
};

export default DealField;
